<template>
  <ContentWithImage src="maintenance" image-order="1" image-order-sm="1" margin="50px 0">
    <text-container>
      <h2 class="h1" v-html="$t(`maintenance.title`)"/>
      <p v-html="$t(`maintenance.text`)"/>
    </text-container>
  </ContentWithImage>
</template>

<script>
import ContentWithImage from '@/components/ui/ContentWithImage.vue'

export default {
  name: 'Maintenance',
  components: { ContentWithImage }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/errors/Maintenance.vue